module.exports = __webpack_public_path__ + "assets/img/teacher (26).dcc4a503.png";